import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/globals.css';
import './lib/i18n'; // 引入 i18n 配置
import { installChunkLoadRecovery } from './lib/chunkLoadRecovery';
import { initUrlParamsHandling } from './lib/urlUtils';

// 打印应用版本号
console.log(
  `%c CoveAuto Al %c Release - v${import.meta.env.VITE_APP_VERSION} `,
  'color: #fff; background: #10b981; padding: 5px 0; border-radius: 3px 0 0 3px;',
  'color: #fff; background: #3b82f6; padding: 5px 0; border-radius: 0 3px 3px 0;',
);

// 初始化 URL 参数处理与重定向逻辑
installChunkLoadRecovery();
initUrlParamsHandling();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
